import { convertAppNodeToCanvasTokenNode, type ProgrammaticMessageOptions } from '@air/feature-ag-ui-chat';

import { useEditCanvasStore } from '../store';
import { buildTransformMessage } from './buildTransformMessage';

export type StartExtractLayersForImageNodeParams = {
  nodeId: string;
  sendProgrammaticMessage: (message: string, options?: ProgrammaticMessageOptions) => Promise<void>;
};

export const startExtractLayersForImageNode = async ({
  nodeId,
  sendProgrammaticMessage,
}: StartExtractLayersForImageNodeParams) => {
  const appNode = useEditCanvasStore.getState().nodes.find((node) => node.id === nodeId);
  const height = appNode?.height ?? (typeof appNode?.style?.height === 'number' ? appNode.style.height : 0);
  const width = appNode?.width ?? (typeof appNode?.style?.width === 'number' ? appNode.style.width : 0);

  useEditCanvasStore.getState().updateNodeData(nodeId, { isProcessing: true });

  try {
    const message = buildTransformMessage({ height, nodeId, type: 'extractLayers', width });
    const sourceNode = appNode ? convertAppNodeToCanvasTokenNode(appNode) : undefined;
    await sendProgrammaticMessage(message, { actionName: 'extractLayers', sourceNode, sourceNodeId: nodeId });
  } finally {
    useEditCanvasStore.getState().updateNodeData(nodeId, { isProcessing: false });
  }
};
